import React from 'react';

import Tag from '@atlaskit/tag';

export default (): React.JSX.Element => (
	<Tag text="Tag link" href="/components/tag" isRemovable={false} />
);
